<template>
    
      <span>{{ getClientsCount(params.value) }}</span>
      
</template>

<script>
import PartnerService from "@/services/PartnerService";

export default {
  name: 'CellRendererClients',
  computed: {
       getClientsCount () {
       PartnerService.getClients(this.params.value)
        .then((obj) => {
          if(obj.val()){
          const count = Object.keys(obj.val()).length
          return count
          }
          else{
            return 0
          }
        })
        .catch(e => {
          console.log('error',e);
        });
    }
  },
}
</script>

